import NewsletterForm from "util/NewsletterForm";

export function handleNewsletterForms() {
    let $forms = $(".js-signup-form");

    if ($forms.length > 0) {
        $forms.each((i, el) => {
            let $el = $(el);
            new NewsletterForm($el);
        });
    }
}